// Premissas · Equipamentos e Materiais: mesma visão executiva de Premissas de Faturamento /
// Custo Mão de Obra. Espelha backend/config.py ROLES_PREMISSAS_EQUIPAMENTOS — mantenha em sincronia.
export const ROLES_PREMISSAS_EQUIPAMENTOS = ["admin", "EXECUTIVA", "GESTOR_ESTRATEGICO"];
